/**
 * Swap Service
 * API functions for currency swap operations using React Query
 */

import { API } from '@/utils/helper';
import { getUID } from '@/utils/helper';

/**
 * Get swap estimate
 * @param {string} fromCurrency - Source currency
 * @param {string} toCurrency - Target currency
 * @param {number} amount - Amount to swap
 * @returns {Promise}
 */
export const getSwapEstimate = async (fromCurrency, toCurrency, amount) => {
  const response = await fetch(
    `${API}/internalswap/estimate?fromCurrency=${fromCurrency}&toCurrency=${toCurrency}&amount=${amount}`
  );
  if (!response.ok) {
    throw new Error('Failed to fetch swap estimate');
  }
  return response.json();
};

/**
 * Perform currency swap
 * @param {object} payload - Swap payload
 * @returns {Promise}
 */
export const performSwap = async (payload) => {
  const response = await fetch(`${API}/internalswap/swap`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      uid: getUID(),
      ...payload
    })
  });
  
  if (!response.ok) {
    throw new Error('Swap failed');
  }
  return response.json();
};
